<div class="inbox-wrapper">


    <div class="notification-icon" (click)="presentPopover($event)">
        <img src="assets/images/icons/notifications.svg" alt="notification" width="21px">
        <ion-badge  *ngIf="this.unreadNotifications$ | async" class="round-badge" >{{ this.unreadNotifications$ | async }}</ion-badge>

    </div>


    <ion-popover #popover [isOpen]="isPopoverInbox " (didDismiss)="isPopoverInbox= false"
                 alignment="center" side="bottom"  size="auto" class="inbox-popover" mode="ios" >
        <ng-template>
            <ion-content class="inbox-notifications-wrapper" [ngClass]="{'width-200':  availableNotifications && availableNotifications.length === 0}" >
                <ion-list [inset]="true" *ngIf="availableNotifications && availableNotifications.length>0" lines="inset">
                    <ion-item *ngFor="let notification of availableNotifications"
                              class="item notification"
                              [ngClass]="{'unopened':notification.status === 'UNOPENED'}"
                              (click)="openNotificationUrl(notification.id, notification.link, notification)"

                    >

                        <div class="item-image" *ngIf="notification.image">
                            <img src="{{notification.image}}" alt="notification" >
                        </div>

                        <div class="info">

                            <div class="title">
                                {{notification.title}}


                                    <svg *ngIf="notification.status === 'UNOPENED'" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="6" height="6" rx="3" fill="#83B25F"/>
                                    </svg>

                            </div>

                            <div class="description" *ngIf="notification.content" [innerHTML]="notification.content" >

                            </div>

                            <div class="date">
<!--                                {{formatDate(notification.createdDate)}}-->
                                {{notification.createdDateString}}

                            </div>


                        </div>



                    </ion-item>
                </ion-list>

                <div class="no-notification-wrapper" *ngIf="availableNotifications &&availableNotifications.length === 0" >

                    <div class="title">
                        Немає нових повідомлень

                    </div>



                </div>
            </ion-content>
        </ng-template>
    </ion-popover>






</div>
